import classNames from 'classnames';
import useParkplusStoreV2 from 'src/modules/parkplusStoreV2/hooks/useParkplusStoreV2';
import Icon from 'ui-v2/components/Icon/Icon';
import { Typography } from 'ui-v2/components/Typography';
import s from './ShipRocketShimmer.module.scss';

const ShipRocketShimmer = ({ error }) => {
  const { deliveryAddressData } = useParkplusStoreV2();

  return (
    <>
      {!error && deliveryAddressData?.toString()?.length > 0 ? (
        <div className={s.deliveryShimmer}>
          <div className={s.delivery_message}>
            <Icon name="TruckRegular" color="secondary" width={16} height={16} />
            <Typography
              label="Delivery by"
              variant="tiny_medium"
              color="secondary"
            />
            <div className={classNames(s.shimmer, 'cmn_shimmer')}></div>
          </div>
        </div>
      ) : (
        <div className={s.deliveryShimmer}>
          <div className={s.delivery_message}>
            <Icon name="TruckRegular" color="secondary" width={16} height={16} />
            <Typography
              label="Delivery within"
              variant="tiny_medium"
              color="secondary"
            />
            <div>
              <Typography
                label="6-7 days"
                variant="tiny_medium"
                color="secondary"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShipRocketShimmer;
